module.exports = "data:application/octet-stream;base64,Lkxhbmd1YWdlc0xpc3QgewogIHBvc2l0aW9uOiByZWxhdGl2ZTsKfQo="


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguagesList.scss
// module id = 643
// module chunks = 0